import { defineAsyncComponent } from "vue";

const MainMenu = defineAsyncComponent(() => import("./main-menu.vue"));
const MenuItem = defineAsyncComponent(() => import("./menu-item.vue"));

export default {MainMenu, MenuItem};